import React from "react";
import {IonText} from "@ionic/react";

export interface SlotHolidayLabelProps {
    label?: string | null;
}

const SlotHolidayLabel: React.FC<SlotHolidayLabelProps> = ({label}) => {
    if (!label) {
        return null;
    }
    return <IonText className="slot-holiday-label">{label}</IonText>;
};

export default SlotHolidayLabel;
